module.exports = __webpack_public_path__ + "img/intro-svg-mobile.33acc0ef.svg";